import { useEffect, useState } from 'react';

import type { ExpiryEvent } from '@services/accountService';

import { useAccountService } from './useAccountService';

export function useOptionExpiry() {
  const [currentExpiryEvent, setCurrentExpiryEvent] =
    useState<ExpiryEvent | null>(null);
  const accountService = useAccountService();

  useEffect(() => {
    const unsubscribe = accountService.subscribeToExpiry(
      (event: ExpiryEvent) => {
        setCurrentExpiryEvent(event);
      },
    );

    return () => {
      unsubscribe();
    };
  }, [accountService]);

  const dismissExpiryEvent = () => {
    setCurrentExpiryEvent(null);
  };

  return {
    currentExpiryEvent,
    dismissExpiryEvent,
  };
}
